const BATCH_REGEX = /^[0-9]{3}\/[0-9]{1,3}$/

export class ConcatenatedBatches {
  private _batches: string

  constructor (concatenatedBatches: string) {
    this.validateString(concatenatedBatches)
    this._batches = concatenatedBatches
  }

  private validateString (value: string) {
    const batches = value.split('-')
    for (const batchId of batches) {
      if (BATCH_REGEX.test(batchId) === false) {
        throw new TypeError('Wrong format for concatenatedBatches')
      }
    }
  }

  value (): string {
    return this._batches
  }
}
